import { JPG_TO_PNG_TOOL } from '@quicktools/shared-components/data/tools';

import { IApplicationConfig } from './types';

export const BASE_URL = `${process.env.NX_DEPLOY_PATH}${process.env.NX_DEPLOY_SUFFIX}`;
export const VERSION = process.env.NX_APP_VERSION;

export const TOOL_NAME = JPG_TO_PNG_TOOL.id;

export const TRACKING_ID = process.env.NX_TRACKING_ID;
export const TRACKING_ID_4 = process.env.NX_TRACKING_ID_4;
export const HOTJAR_ID = Number(process.env.NX_HOTJAR_ID);
export const BUGSNAG_ID = process.env.NX_BUGSNAG_ID;
export const OPTIMIZE_ID = process.env.NX_OPTIMIZE_ID;
export const ONETRUST_ID = process.env.NX_ONETRUST_ID;

export const resultType = 'image/png';
export const canonicalPath = 'convert/jpg-to-png/';

export const sourceLower = 'jpg';
export const sourceUpper = 'JPG';
export const resultLower = 'png';
export const resultUpper = 'PNG';

export const appConfig = {
  accept: 'image/jpeg, image/jpeg, image/jpe, image/jif, image/jfif, image/jpg',
  multiple: true,
  heroBannerImgUrl: 'https://cdn140.picsart.com/91964687801994521839.webp',
  heroBannerImgAlt: 'convert jpg to png online',
};

export const applicationI18N: IApplicationConfig = {
  header: {
    iconUrl: 'https://cdn140.picsart.com/17036616863317208049.svg',
    iconAlt: `${sourceUpper} TO ${resultUpper} CONVERTER`,
  },
  home: {
    heroBanner: {
      heading: `Convert ${sourceUpper} to ${resultUpper} Online`,
      content: `This online ${sourceUpper} to ${resultUpper} converter is the easiest and fastest way to convert your ${sourceUpper}s into ${resultUpper}s. Just upload an image, convert it, and download your ${resultUpper}. Give your images a spin!`,
      imgSrc: 'https://cdn140.picsart.com/22089939165255246701.png',
      imgAlt: `${sourceUpper} TO ${resultUpper}`,
      uploadArea: {
        text: '',
        uploadButtonLabel: {
          desktop: `Select Image`,
          mobile: `Select ${sourceLower} Image`,
        },
      },
    },
    uploadButtonTitle: 'CHANGE_IT',
    uploadButtonProcessingTitle: 'CHANGE_IT',
  },

  notification: {
    general: {
      title: {
        success: 'Success',
        error: 'Error',
      },
    },
    converting: {
      title: 'Uploading & Converting...',
      message: `Your ${sourceUpper} images are being processed`,
    },
    converted: {
      title: '',
      message: `Your ${sourceUpper}(s) were successfully converted to ${resultUpper}(s)`,
    },
    downloaded: {
      title: '',
      message: `Your ${resultUpper}s were successfully downloaded`,
    },
    error: {
      message: 'Something went wrong!',
    },
    uploadError: {
      message: 'Please upload only JPG Images',
    },
  },
  modals: {
    startOver: 'You are about to start over. Do you wish to continue?',
    deleteFile: 'Are you sure you want to delete this file?',
  },
};
